/* eslint-disable @typescript-eslint/indent */
import { Typography } from '@pwskills/rachnaui';
import { classNames } from '@pwskills/rachnaui/utils';
import { useRouter } from 'next/router';

const MasterclassHeader = ({
  headerText,
  className,
}: {
  headerText: string;
  className?: string;
}) => {
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  return (
    <Typography
      component={isDashboard ? 'subheading' : 'h2'}
      variant="bold"
      className={
        isDashboard
          ? 'text-left text-gray-850'
          : classNames(
              className || '',
              '!text-[24px] leading-9 medium:!text-[32px] medium:!leading-10'
            )
      }
    >
      {headerText}
    </Typography>
  );
};

export default MasterclassHeader;
